import { API_ENDPOINTS } from '@/config/api';
import { apiClient } from '@/services/api/client';
import type { BackendApiResponse } from '@/types/general-enquiry';
import type { EnquirySourceEventResponse, RecordEnquiryRevealPayload } from '@/types/enquiry';

export const enquiryApi = {
  /**
   * Records an enquiry reveal interaction (phone or email).
   */
  async recordReveal(
    payload: RecordEnquiryRevealPayload,
  ): Promise<EnquirySourceEventResponse | null> {
    const response = await apiClient.post<BackendApiResponse<EnquirySourceEventResponse>>(
      API_ENDPOINTS.enquiries.reveal,
      payload,
      {
        skipSuccessToast: true,
        skipErrorToast: true,
      },
    );
    return response?.data?.data ?? null;
  },
};

/**
 * Fire-and-forget helper to record enquiry reveal events safely.
 * Will not reject or bubble errors to UI callers.
 */
export async function recordEnquiryReveal(
  payload: RecordEnquiryRevealPayload,
): Promise<EnquirySourceEventResponse | null> {
  try {
    return await enquiryApi.recordReveal(payload);
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Failed to record enquiry reveal event:', error);
    }
    return null;
  }
}
